module.exports = __webpack_public_path__ + "static/Kuba-f97b54aa370bb1ba20af66647222b71b.mp4";